<div class="flex flex-col gap-y-4">
  <h2 class="text-xl leading-8">Правила учёта выходных и праздничных дней</h2>
  <com-form-item>
    <div class="flex flex-col gap-y-2">
      <com-form-checkbox label="Правила по умолчанию" [control]="defaultControl"></com-form-checkbox>
      <ng-container *ngIf="!defaultControl.value">
        <com-form-toggle
          beforeLabel="Расчёт в календарных днях"
          afterLabel="Расчёт в рабочих днях"
          [control]="weekendControl"
        ></com-form-toggle>
        <div *ngIf="weekendControl.value" class="flex items-center gap-x-4">
          <span>Выходные дни:</span>
          <com-form-checkbox
            label="Суббота"
            [control]="formGroup.get('excludeSaturdays')"
          ></com-form-checkbox>
          <com-form-checkbox
            label="Воскресенье"
            [control]="formGroup.get('excludeSundays')"
          ></com-form-checkbox>
        </div>
        <com-form-toggle
          beforeLabel="Без учёта праздничных дней"
          afterLabel="Не выставлять на праздничные дни"
          [control]="formGroup.get('excludeHolidays')"
        ></com-form-toggle>
        <ng-container
          *ngIf="showShiftControls && (weekendControl.value || formGroup.get('excludeHolidays').value)"
        >
          <com-form-checkbox
            label="Переносить на рабочие дни"
            [control]="formGroup.get('shiftHolidays')"
          ></com-form-checkbox>
          <com-form-toggle
            *ngIf="formGroup.get('shiftHolidays').value"
            beforeLabel="На ближайший назад"
            afterLabel="На ближайший вперед"
            [control]="formGroup.get('shiftForward')"
          ></com-form-toggle
        ></ng-container>
      </ng-container>
    </div>
  </com-form-item>
</div>
